// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__DO8nO","title":"CardHeader_title__Rr7s6"};